export const CarCategoryApi = 'wx/carcategory/' // 车系信息,所有信息 结构：p i n c
export const CarCategoryChildrenApi = 'wx/carcategorychildren/' // 车的子级信息
export const AreaShortApi = 'wx/areashort/' //获得所属店铺区域
export const AreaApi = 'basic/area/' //获得所属店铺区域
export const getAreaApi = 'basic/GetArea' // 根据parent 获得下级区域
